export default {
	namespaced: true,
	state: () => ({
		curPackage: {},
		curPayChannel: {},
		deductionChecked: false,
		retainModalInfo: {},
		// 限时领取按钮控制参数
		lottieNeedShow: true,
		// 动画展示控制参数
		lottieShow: true,
	}),
	mutations: {
		setCurPackage(state, data) {
			state.curPackage = data || {};
		},
		setCurPayChannel(state, data) {
			state.curPayChannel = { ...data };
		},
		setDeductionChecked(state, data) {
			state.deductionChecked = data;
		},
		setRetainModalInfo(state, data) {
			state.retainModalInfo = { ...data };
		},
		setLottieNeedShow(state, data) {
			state.lottieNeedShow = data;
		},
		setLottieShow(state, data) {
			state.lottieShow = data;
		},
	},
	actions: {},
	getters: {
		curPackage: (state) => {
			return state.curPackage;
		},
		curPayChannel: (state) => {
			return state.curPayChannel;
		},
		deductionChecked: (state) => {
			return state.deductionChecked;
		},
		retainModalInfo: (state) => {
			return state.retainModalInfo;
		},
		lottieNeedShow: (state) => {
			return state.lottieNeedShow;
		},
		lottieShow: (state) => {
			return state.lottieShow;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/ActivityPage/modules/membership-system.js